import { Jwt } from '@pkg/classes';

import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

export function validateAuthTokens() {
    const tokens = useAuthTokens.getState().token;
    let isAuthenticated = false;

    if (tokens) {
        useAuthTokens.getState().setHasPassword(!!tokens.has_password);

        try {
            const jwt = new Jwt(tokens.access_token);
            if (!jwt.isExpired()) {
                // TODO: Validate 2FA check
                // isAuthenticated = !tokens.requires_2fa || !jwt.is2FAExpired();
                isAuthenticated = true;

                if (jwt.jwt?.sub) {
                    useAuthTokens.getState().setCurrentUserId(jwt.jwt.sub);
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Error parsing JWT: ${e}`);
        }

        if (!isAuthenticated) {
            useAuthTokens.getState().setRefreshToken(tokens.refresh_token);
        }
    }
    useAuthTokens.getState().setIsAuthenticated(isAuthenticated);
}
